import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const UnknownLocationIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M5.32328 9.69922C5.4224 10.2303 5.62671 10.9036 5.96684 11.7119C6.45902 12.8774 7.15751 14.1651 7.95903 15.4668C9.29027 17.638 10.8375 19.734 12 21.2285C12.8035 20.1988 13.7882 18.8754 14.7608 17.4404L16.5079 18.874C15.242 20.7262 13.9781 22.3735 13.1114 23.4609C12.5348 24.18 11.4653 24.18 10.8887 23.4609C8.48402 20.4437 3.00012 13.1309 3.00004 9.02344C3.00004 8.62825 3.028 8.23923 3.07719 7.85742L5.32328 9.69922Z"
            fill="currentColor"
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 0C16.9688 0 21 4.0418 21 9.02344C21 10.9302 19.8143 13.5252 18.3067 16.0625L23.3975 20.2383C23.7711 20.5458 23.8345 21.111 23.5391 21.5C23.2437 21.8888 22.7008 21.9549 22.3272 21.6475L0.328166 3.60254C-0.0455436 3.29505 -0.109786 2.72986 0.185588 2.34082C0.48097 1.95183 1.02381 1.88589 1.3975 2.19336L4.21098 4.50098C5.76924 1.81028 8.67472 2.76877e-06 12 0ZM12 2.25586C9.37505 2.25586 7.09946 3.75998 5.98344 5.95508L16.5469 14.6191C17.1351 13.6095 17.6482 12.6238 18.0332 11.7119C18.5395 10.5089 18.75 9.6062 18.75 9.02344C18.75 5.28721 15.7266 2.25586 12 2.25586Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default UnknownLocationIcon
